import { render, staticRenderFns } from "./TownshipChoose.vue?vue&type=template&id=4b461fb6&scoped=true&"
import script from "./TownshipChoose.vue?vue&type=script&lang=js&"
export * from "./TownshipChoose.vue?vue&type=script&lang=js&"
import style0 from "./TownshipChoose.vue?vue&type=style&index=0&id=4b461fb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b461fb6",
  null
  
)

export default component.exports